import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a656093")

_pushScopeId("data-v-7a656093")
const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_KpiDocumentDesignerScorecardSelectDialog = _resolveComponent("KpiDocumentDesignerScorecardSelectDialog")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.scorecardList')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("div", null, [
        _createVNode(_component_DataTable, {
          value: _ctx.scorecards,
          class: "p-datatable-sm kn-table",
          dataKey: "name",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.globalFilterFields,
          responsiveLayout: "stack",
          breakpoint: "960px",
          scrollable: true,
          "scroll-height": "60vh"
        }, {
          header: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("span", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  type: "text",
                  placeholder: _ctx.$t('common.search')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createVNode(_component_Button, {
                id: "kpi-edit-add-scorecard-association-button",
                class: "kn-button kn-button--primary",
                label: _ctx.$t('kpi.kpiDocumentDesigner.addScorecardAssociation'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addScorecardVisible = true))
              }, null, 8, ["label"])
            ])
          ]),
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withId(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              field: "name",
              header: _ctx.$t('common.name'),
              key: "name",
              sortable: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              field: "creationDate",
              header: _ctx.$t('common.creationDate'),
              key: "dateCreation",
              sortable: true
            }, {
              body: _withId((slotProps) => [
                _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.creationDate)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              style: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.iconColumnStyle
            }, {
              body: _withId((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteScorecardConfirm(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields"])
      ]),
      _createVNode(_component_KpiDocumentDesignerScorecardSelectDialog, {
        scorecardList: _ctx.scorecardList,
        visible: _ctx.addScorecardVisible,
        dataScorecards: _ctx.scorecards,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addScorecardVisible = false)),
        onScorecardSelected: _ctx.onScorecardSelected
      }, null, 8, ["scorecardList", "visible", "dataScorecards", "onScorecardSelected"])
    ]),
    _: 1
  }))
})